import { labelOnly } from "../label-only";
import type { ToolActivity } from "../tool-activity";
import { toolInput } from "../tool-input";

export function describeMemorySearch(
  record: Record<string, unknown>,
): ToolActivity {
  const query = toolInput.str(record.query);
  return labelOnly(
    query
      ? `Searched its memory: ${toolInput.truncate(query, 60)}`
      : "Searched its memory",
  );
}
